import MdContent from './MdContent.vue';
import { App } from 'vue';
export const defineContentComponent = (app: App) => {
  // material(Vue)
  console.log('defineContentComponent', MdContent.name, MdContent);
  app.component(MdContent.name ?? 'MdContent', MdContent);
};
